import { createSelector } from 'reselect'

const getCurrencyRates = state => state.currency.currencyRates

export const selectCurrencyRate = () =>
  createSelector(
    getCurrencyRates,
    currencyRates => currencyRates
  )
